import PropTypes from 'prop-types'
import React from 'react'
import { usePage } from 'publisher/store'
import pageSelectors from 'publisher/store/page/pageSelectors'
import Meta from '../../components/core/Meta'
import PageUi from '../ui/PageUi'
import { BlogOnExitPopup } from './blog-on-exit-popup'
import { BlogOnloadPopups } from './blog-onload-popups'
import { BlogTriggeredPopup } from './blog-triggered-popup'

function BlogPage({ children }) {
  const globalTextFontProperties = usePage(
    pageSelectors.getGlobalFontProperties,
  )
  return (
    <PageUi
      $textFontFamily={globalTextFontProperties.fontFamily}
      $textFontWeight={globalTextFontProperties.fontWeight}
      $textFontStyle={globalTextFontProperties.fontStyle}
    >
      <Meta />
      {children}
      <BlogTriggeredPopup />
      <BlogOnExitPopup />
      <BlogOnloadPopups />
    </PageUi>
  )
}

BlogPage.propTypes = {
  children: PropTypes.node.isRequired,
}

export default BlogPage
